module.exports = __webpack_public_path__ + "static/media/tortilla.eeba4abd.svg";